export type TikTokPayload = {
  value?: number;
  currency?: string;
  contents?: Array<{
    content_id: string;
    content_type: string;
    content_name?: string;
    quantity: number;
    price: number;
  }>;
  event_id?: string;
  search_string?: string;
  context?: {
    page?: { url?: string };
    user?: { _ttp?: string };
  };
};

export type AmplitudeEvent = 'signup' |
  'paid' |
  'no-preferences-after-signup' |
  'resubscribe-payment-started' |
  'resubscribe-flow-started' |
  'fix-past-due-started' |
  'payment-started' |
  'payment-success' |
  'address-flow-started' |
  'address-flow-success' |
  'household-flow-started' |
  'household-flow-success' |
  'income-flow-started' |
  'income-flow-success' |
  'mandatory-flow-success' |
  'signup-success' |
  'signup-failed' |
  'signup-start' |
  'login-after-signup' |
  'login-start' |
  'login-success' |
  'login-failed' |
  'password-reset-requested' |
  'ineligible-page' |
  'stay-homey-discount-opened' |
  'stay-homey-discount-applied' |
  'stay-homey-discount-ignored' |
  'payment-canceled' |
  'refer-button-pressed' |
  'referral-link-copied' |
  'referral-link-shared' |
  'visible-error' |
  'homey-share' |
  'share-apartment' |
  'push-notification-clicked' |
  'housing-connect-password-got' |
  'promotion-header-clicked' |
  'rate-homey-rating-submitted' |
  'rate-homey-description-submitted' |
  'click-tracked' |
  'benefits-page-viewed';

export type PaymentEventFlow = 'initial' | 'resubscribe';
export type PaymentEventProperties = {
  flow: PaymentEventFlow;
  checkoutLocation: 'default' | 'deferred' | 'deferred-no-trial';
  interval: 'monthly' | 'annual' | 'unknown' | 'revenuecat' | 'deferred';
};

export abstract class AnalyticsService {
  abstract sendEvent(event: AmplitudeEvent, properties?: Record<string, string | number | undefined>): Promise<void>;
  abstract setClickSource(source: string, url: string, variant?: string): Promise<void>;
  abstract buildPaymentEventProperties(base: {flow: PaymentEventFlow; checkoutLocation: PaymentEventProperties['checkoutLocation']; interval?: PaymentEventProperties['interval']}): PaymentEventProperties;
  abstract sendPaymentStarted(params: {flow: PaymentEventFlow; interval: 'monthly' | 'annual'; checkoutLocation: PaymentEventProperties['checkoutLocation']; amount: number;}): Promise<void>;
  abstract sendPaymentSuccess(params: {flow: PaymentEventFlow; checkoutLocation: PaymentEventProperties['checkoutLocation']; interval: PaymentEventProperties['interval']; amount?: number;}): Promise<void>;
  abstract getUTMData(): {utmSource: string; utmCampaign: string};
  abstract initialize(): void;
}
